import mainServer from '@/api/index'
import vueI18n from 'vue-i18n';

const state = {
    bankList: [],
    roleList: [],
    countryMap: {
        AT: "奥地利",
        BG: "保加利亚",
        CZ: "捷克共和国",
        DK: "丹麦",
        EE: "爱沙尼亚",
        FI: "芬兰",
        FR: "法国(南)",
        DE: "德国",
        GR: "希腊",
        HU: "匈牙利",
        IE: "爱尔兰",
        LV: "拉脱维亚",
        LT: "立陶宛",
        LU: "卢森堡",
        PL: "波兰",
        PT: "葡萄牙",
        RO: "罗马尼亚",
        SK: "斯洛伐克",
        SI: "斯洛文尼亚",
        SE: "瑞典",
        GB: "英国",
        CN: "中国",
        US: "美国",
        BE: "比利时",
        ES: "西班牙",
        IT: "意大利",
        NL: "荷兰",
        MX: "墨西哥"
    }
};

const mutations = {

    setBankList(state, data) {
        state.bankList = data;
    },
    setRoleList(state, data) {
        state.roleList = data;
    }
};

const actions = {

    loadBankList({
        commit,
        state
    }, status) {
        mainServer.queryBankList({}).then((res) => {
            commit('setBankList', res.data)
        });
    },
    loadRoleList({
        commit,
        state
    }, status) {
        mainServer.queryRoleList({}).then((res) => {
            commit('setRoleList', res.data.records);
        });
    },
};

export default {
    state,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/keyvalue.js